import axios from 'axios'
import HTTP from './http'

export default {
    list: () => axios.get(`${HTTP.FLYERS}/all`),
    create: (body: FormData) => axios.post(HTTP.FLYERS, body),
    update: (id: number | string, body: FormData) => axios.put(`${HTTP.FLYERS}/${id}`, body),
    publish: () => axios.post(`${HTTP.FLYERS}/publish`),
    remove: (id: number | string) => axios.delete(`${HTTP.FLYERS}/${id}`),
    preview: (id: number | string, body: FormData) =>
        axios.post(`${HTTP.FLYERS}/${id}/preview`, body, { responseType: 'blob' })
}
